export default "__VITE_ASSET__BEOjWsXL__"